// extracted by mini-css-extract-plugin
module.exports = {"mt20":"Styles_mt20__3vCXF","mt30":"Styles_mt30__1KvUw","fullWidth":"Styles_fullWidth__2QiVz","orgWrapper":"Styles_orgWrapper__1h3P6","table":"Styles_table__3mVd3"};